export enum ServiceType {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  NONE = ''
}
